module.exports = __webpack_public_path__ + "static/media/sf_2000_gray.4a6e106a23f06c3429dea792e3aaf20b.png";